import React from 'react'
import '@Styles/mandate.css';
import { Loader } from '../Common/Loader';
import { connect } from "react-redux";
import { useEffect } from 'react';
import { useState } from 'react';
import { getGenralUserDetail } from '@Redux/GeneralDetails/action';
import ToastMsg from '../../../helper/ToastMsg';

const   PersonalLoanUserJourney=(props)=> {
const [Pending,SetPending]=useState(true);
    useEffect(() => {
        handleGetUserDetail()
    }, [])
    
    // localStorage.getItem("gpay_refresh_token")
const handleGetUserDetail=()=>{
    props.getGenralUserDetail(localStorage.getItem("gpay_token"))
      .then((res) => {

        const can_apply_for_loan=res?.data?.data?.customusermodel?.can_apply_for_loan

        let loan_array=res?.data?.data?.customusermodel?.usercredit;

        const loan_type_array=loan_array?.filter((obj)=>obj.loan_type!='P')

        const user_credit_limit_array=loan_array?.filter((obj)=>obj.credit_limit!=null && obj.loan_type!='P' )

        let loan_type=(loan_type_array ?loan_type_array:[]);

        let user_credit_limit=(user_credit_limit_array?user_credit_limit_array:[]);

        // console.log(loan_type)
        // console.log(user_credit_limit.length)
        localStorage.setItem('from_deeplink',true);
      
         if(user_credit_limit.length==0)
        {
          window.location.href='/completeprofilenew';
        }
        else if(!can_apply_for_loan)
        {
          window.location.href='/dashboard_s';
        }
        else{

          if(can_apply_for_loan  &&  loan_type.length>0)
          {

          if(user_credit_limit.length>0)
          {
                window.location.href='/applyloanemi';
          }
          else{
            window.location.href='/completeprofilenew';
          }
          }
          else{
            window.location.href='/dashboard_s';
          }
        }
        
      })
      .catch((err) => {
        SetPending(false);
        if (err==401 ||err?.response?.status === 401) {    
          localStorage.clear();
          window.location.href = "/?is_deeplink=True";   
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        
      });
}


  return (
    <div className="main_div payme_body">
      <div className="container">
        {Pending?<Loader/>:<></>}
    <div className='personal_loan_user_journey'></div>
      </div>
    </div>
  )
}


const mapStateToProps = (state) => {
    console.log("personal user journey  test ", state);
    return {
      user: state.user,
      userDetails: state,
    };
  };

  export default connect(mapStateToProps, {getGenralUserDetail},)(PersonalLoanUserJourney);